import React__default from 'react';
import PropTypes from 'prop-types';
import { ScrollableSpan, TruncatedSpan } from './Truncated.styles.js';

var Truncated = function Truncated(_ref) {
  var children = _ref.children,
    _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? false : _ref$expanded,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'middle' : _ref$position;
  if (expanded) {
    return React__default.createElement(ScrollableSpan, null, children);
  }
  if (position === 'end') {
    return React__default.createElement(TruncatedSpan, {
      $position: "end"
    }, children);
  }
  var middle = Math.ceil(children.length / 2);
  var start = children.substring(0, middle);
  var end = children.substring(middle);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(TruncatedSpan, {
    $position: "end"
  }, start), React__default.createElement(TruncatedSpan, {
    $position: "middle"
  }, end));
};
Truncated.propTypes = {
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  position: PropTypes.oneOf(['end', 'middle'])
};

export { Truncated, Truncated as default };
//# sourceMappingURL=Truncated.js.map
